module.exports = __webpack_public_path__ + "assets/img/chinese-btn.0bd25e32.png";